import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import CookieValue from "../../../utils/cookie_value";
import FetchResource from "../../../utils/fetch_resource";
import ApiCall from "../../../utils/api_call";
import Spinner from "../../Spinner";
import LogIf from "../../../utils/log_if";

const api_base = process.env.API_URL;
const client_base = process.env.BASE_URL;

export default class EventsIndexMainContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current_user_id: null,
      events: [],
      current_tab: "my_upcoming",
      event_tab_options: {},
      syllabi: [],
      syllabi_selection: "",
      page_number: 1,
      notice_message: "",
      display_notice: false,
      display_error: false,
      data_ready: false,
      // user_role: props.userRole,
      permissions: {},
    };
    this._localTzOpts = this.localTzOpts();
  }

  componentDidMount = () => {
    this._isMounted = true;
    //Load page data
    // console.log("mounted component")
    this.fetchEvents({})
      .then(() => {
        this.setState({ data_ready: true });
      })
      .catch((err) => {
        if (err === "Unauthorized") {
          const cookies = new Cookies();
          cookies.remove("user_auth");
          this.props.history.push("/log_in");
        } else {
          this.setState({ display_error: true });
        }
      });
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };

  componentDidUpdate = (prevProps, prevState, snapshot) => {
    if (this.state.currentUserId != this.props.currentUserId) {
      this.setState({ currentUserId: this.props.currentUserId });
    }
    if (prevState.current_tab !== this.state.current_tab) {
      this.fetchEvents();
    }
  };

  fetchEvents = () => {
    return FetchResource(api_base + "events", this.buildFetchParams(), this);
  };

  /****/
  handleCancelEvent = (evnt) => {
    if (
      confirm(
        `Are you sure you want to cancel the event, "${evnt.summary}"? PLEASE NOTE: a cancelation message will be sent to any email currently on the event's invitees list.`
      )
    ) {
      this.cancelEvent(evnt);
    }
  };

  /**
   * Cancel event and send notification of cancelation to
   * invitees if cancelation is confirmed.
   **/
  cancelEvent = (evnt) => {
    let state = this.state;
    const event_id = evnt.id;
    const url = api_base + "events/cancel_event";
    const reqOptions = {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + CookieValue(),
      },
      body: JSON.stringify({ id: event_id }),
    };
    ApiCall(url, reqOptions, this)
      .then((data) => {
        // console.log(data);
        if (
          !data.errors &&
          data.res_status != "unauthorized" &&
          data.status != 500
        ) {
          state["display_notice"] = true;
          state["display_error"] = false;
          state["notice_message"] =
            "Success: emailed " +
            data["emails_sent"] +
            " invitees with cancelation.";
        } else {
          state["display_notice"] = false;
          state["display_error"] = true;
          state["notice_message"] = JSON.stringify(data.errors || data.error);
        }
        // $(window).scrollTop(0);
        this.fetchEvents();
      })
      .catch((err) => {
        state["display_notice"] = false;
        state["display_error"] = true;
        state["notice_message"] = "Failed to email invitees.";
        // $(window).scrollTop(0);
        this.setState(state);
        this.fetchEvents();
      });
  };

  buildFetchParams = () => {
    let sylId = this.state.syllabi_selection;
    return (
      "current_tab=" +
      this.state.current_tab +
      "&" +
      (sylId ? "event[syl_events][syllabus_id]=" + sylId : "")
    );
  };

  buildQuery = (key, paramName) => {
    return (
      paramName +
      "=" +
      this.state[key]
        .map((s, i) => {
          return s.id;
        })
        .join(",")
    );
  };

  handleDropdownChange = (key, event) => {
    let state = this.state;
    state[key] = event.target.value;
    this.setState(state);
  };

  generateNoticeDiv = () => {
    let { display_error, display_notice, notice_message } = this.state;
    return display_error || display_notice ? (
      <div
        role="alert"
        className={
          "card inner-buffer " +
          (display_error ? "alert alert-danger" : "alert alert-success")
        }
      >
        {notice_message}
      </div>
    ) : (
      ""
    );
  };

  generateAddEventBtn = (canCreate) => {
    return canCreate ? (
      <div
        className="btn-group mr-2"
        role="group"
        aria-label="Event management actions"
      >
        <a href="../event/new">
          <button id="newEventBtn" className="btn btn-primary">
            Add Event
          </button>
        </a>
      </div>
    ) : (
      ""
    );
  };

  generateSylDropdownBar = () => {
    let syllabi = this.state.syllabi;
    const sylOpts = syllabi.map((syl, i) => {
      const course_code = syl["course_code_a"].replaceAll(",", "");
      const course_name = syl["course_name"];
      const label = course_code + " " + course_name;
      return label == " " ? (
        ""
      ) : (
        <option key={"sylOpt-" + i} value={syl["id"]}>
          {label}
        </option>
      );
    });
    return (
      <div className="mt-1">
        <label className="mr-1">
          <strong>Filter Events By Course:</strong>
        </label>
        <div className="btn-group">
          <select
            className="btn btn-secondary"
            style={{ maxWidth: "20vw" }}
            onChange={(e) => {
              this.handleDropdownChange("syllabi_selection", e);
            }}
          >
            <option value="">--All Courses--</option>
            {sylOpts}
          </select>
          <button className="btn btn-secondary" onClick={this.fetchEvents}>
            Filter
          </button>
        </div>
      </div>
    );
  };

  localTzOpts = () => {
    let options = {};
    try {
      options["timeZone"] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (e) {
      console.error(`Error finding local timezone: ${e}`);
    }
    return options;
  };

  generateTimeZones = (date) => {
    let cairo_opts = {
      hour: "numeric",
      minute: "2-digit",
      timeZoneName: "short",
      timeZone: "Africa/Cairo",
    };
    let ny_opts = {
      hour: "numeric",
      minute: "2-digit",
      timeZoneName: "short",
      timeZone: "America/New_York",
    };
    let la_opts = {
      hour: "numeric",
      minute: "2-digit",
      timeZoneName: "short",
      timeZone: "America/Los_Angeles",
    };
    return (
      <div className="time-zones" style={{ minWidth: "10vw" }}>
        <div
          className="cairo-time"
          title={date.toLocaleString("ar-EG", cairo_opts)}
        >
          {date.toLocaleString("en-US", cairo_opts)}
        </div>
        <div
          className="new-york-time"
          title={date.toLocaleString("ar-EG", ny_opts)}
        >
          {date.toLocaleString("en-US", ny_opts)}
        </div>
        <div
          className="los-angeles-time"
          title={date.toLocaleString("ar-EG", la_opts)}
        >
          {date.toLocaleString("en-US", la_opts)}
        </div>
      </div>
    );
  };

  generateNoneFoundTr = (data_ready) => {
    return (
      <tr>
        <td className="text-muted" colSpan="6">
          {data_ready ? "None Found" : <Spinner />}
        </td>
      </tr>
    );
  };

  generateEventsList = (events, canUpdateAll, currentUserId) => {
    return events.map((evnt, i) => {
      let eventCreator = evnt.created_by.id === currentUserId;
      let start = new Date(evnt.start_time);
      let course_codes =
        evnt["course_codes"].length > 0 ? evnt["course_codes"] + ": " : "";
      let meeting_link_a =
        evnt.meeting_link != null ? (
          <a href={evnt.meeting_link}>
            <div style={{ maxWidth: "15vw", overflow: "auto" }}>
              {evnt.meeting_link}
            </div>
          </a>
        ) : (
          ""
        );
      let event_detail_a = (
        <a href={"../event/" + evnt.id}>
          <button id={"detailBtn-" + evnt.id} className="btn btn-info">
            Detail
          </button>
        </a>
      );
      let cancel_event_btn =
        canUpdateAll || eventCreator ? (
          <button
            className="btn btn-danger ml-1 mt-1"
            onClick={() => {
              this.handleCancelEvent(evnt);
            }}
          >
            CANCEL
          </button>
        ) : (
          ""
        );
      return (
        <tr
          key={i}
          id={`test-event-${evnt.id}`}
          className="justify-content-left buffer-top"
        >
          <td className="inner-buffer test-summary-desc">
            <strong>
              {course_codes}
              {evnt.summary}
            </strong>
            <br />
            {evnt.description}
          </td>
          <td className="inner-buffer test-meeting-num">
            {evnt.meeting_number}
          </td>
          <td className="inner-buffer test-start-date">
            {start.toLocaleDateString("en-US", this._localTzOpts)}
          </td>
          <td className="inner-buffer test-start-time">
            {this.generateTimeZones(start)}
          </td>
          <td className="inner-buffer test-meeting-link">{meeting_link_a}</td>
          <td className="inner-buffer test-actions">
            {event_detail_a}
            {cancel_event_btn}
          </td>
        </tr>
      );
    });
  };

  render() {
    let {
      events,
      current_tab,
      event_tab_options,
      page_number,
      display_notice,
      display_error,
      data_ready,
      permissions,
      currentUserId,
    } = this.state;

    const canUpdateAll = data_ready && permissions["update"];
    const canCreate = data_ready && permissions["create"];
    /** generate the html for events data **/
    const notice = this.generateNoticeDiv();
    const events_list = this.generateEventsList(
      events,
      canUpdateAll,
      currentUserId
    );
    const none_found_tr = this.generateNoneFoundTr(data_ready);
    const add_event_btn = this.generateAddEventBtn(canCreate);
    const event_tabs_btn_group = Object.keys(event_tab_options).map((opt) => {
      let tab = event_tab_options[opt];
      let classes =
        opt === current_tab ? "btn btn-info disabled" : "btn btn-info";
      return (
        <button
          key={"tab" + opt}
          type="button"
          className={classes}
          onClick={() => {
            this.setState({ current_tab: opt });
          }}
        >
          {tab}
        </button>
      );
    });
    const syllabusFilterBar = this.generateSylDropdownBar();

    return (
      <div>
        <div className="container">
          {notice}
          <h1 className="d-flex flex-row justify-content-center">
            {event_tab_options[current_tab]}
          </h1>

          <div
            section="event-tab-options"
            className="btn-toolbar top-buffer"
            role="toolbar"
            aria-label="Event listing tabs"
          >
            {add_event_btn}
            {event_tabs_btn_group}
          </div>
          <div
            section="event-filters"
            className="btn-toolbar"
            role="toolbar"
            aria-label="Event filters"
          >
            {syllabusFilterBar}
          </div>
          <div section="events-list">
            <table className="table table-bordered top-buffer">
              <thead>
                <tr>
                  <th>Event</th>
                  <th>Mtg #</th>
                  <th title="Localized start date.">Start Date</th>
                  <th>Start Time</th>
                  <th>Meeting Link</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>{events.length > 0 ? events_list : none_found_tr}</tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}
